import type { PetitionDetailsPageState } from './types';

export const mutations = {
	updateSignFormStep: (state: PetitionDetailsPageState, step: 1 | 2): PetitionDetailsPageState => ({
		...state,
		signFormStep: step,
	}),
};
